export enum MTGSetType {
    "Archenemy" = "archenemy",
    "Box" = "box",
    "Commander" = "commander",
    "Core" = "core",
    "DraftInnovation" = "draft_innovation",
    "DuelDeck" = "duel_deck",
    "Expansion" = "expansion",
    "FromTheVault" = "from_the_vault",
    "Funny" = "funny",
    "Masterpiece" = "masterpiece",
    "Masters" = "masters",
    "Memorabilia" = "memorabilia",
    "Planechase" = "planechase",
    "PremiumDeck" = "premium_deck",
    "Promo" = "promo",
    "Spellbook" = "spellbook",
    "Starter" = "starter",
    "Token" = "token",
    "Vanguard" = "vanguard",
}
